import * as Yup from 'yup';

import { giftCardAmounts } from 'gift-cards/enums/constants';
import { sharedValidationsMap } from 'shared/utils/validations';

const TP = 'giftCards.utils.validations';

export const detailsModalValidationSchema = (t) =>
  Yup.object().shape(
    {
      // Amount and Custom Amount need to ensure the other exists before validating.
      amount: Yup.number().when(['customAmount'], {
        is: 0 || null,
        then: Yup.number()
          .required(t(`${TP}.requiredAmount`, 'Please select an amount'))
          .oneOf(giftCardAmounts, t(`${TP}.requiredAmount`, 'Please select an amount')),
        otherwise: Yup.number().nullable(),
      }),
      customAmount: Yup.number().when(['amount'], {
        is: 0,
        then: Yup.number()
          .required(t(`${TP}.requiredAmount`, 'Please select an amount'))
          .typeError(t(`${TP}.invalidAmount`, 'Invalid Amount'))
          .lessThan(2001, t(`${TP}.maximumCustomAmountMessage`, 'Amount cannot exceed $2,000'))
          .moreThan(24, t(`${TP}.minimumCustomAmountMessage`, 'Amount must exceed $25')),
        otherwise: Yup.number().nullable(),
      }),
      recipientName: Yup.string()
        .matches(
          /^[^\d!#$%&*+;=@\\^_]+$/,
          t(`${TP}.invalidName`, 'Name cannot contain numbers and special characters'),
        )
        .required(t(`${TP}.requiredRecipientName`, 'To is a required field')),
      senderName: Yup.string()
        .matches(
          /^[^\d!#$%&*+;=@\\^_]+$/,
          t(`${TP}.invalidName`, 'Name cannot contain numbers and special characters'),
        )
        .required(t(`${TP}.requiredSenderName`, 'From is a required field')),
      recipientEmail: Yup.string()
        .email(t(`${TP}.invalidEmail`, 'Enter a valid email address'))
        .required(t(`${TP}.requiredRecipientEmail`, 'Recipient Email is a required field')),
      message: Yup.string().max(100, t(`${TP}.maxCharactersMessage`, 'Max 100 characters')),
    },
    // Need to list co-dependencies here to avoid Yup cyclical dependency error.
    [['amount', 'customAmount']],
  );

export const checkBalanceValidationSchema = (t) =>
  Yup.object().shape({
    email: Yup.string()
      .email(t(`${TP}.invalidEmail`, 'Enter a valid email address'))
      .required(t(`${TP}.requiredEmail`, 'Email is a required field')),
    code: sharedValidationsMap.giftCardCodeValidation(),
  });

export const emailValidationSchema = (t) =>
  Yup.object().shape({
    email: Yup.string()
      .email(t(`${TP}.invalidEmail`, 'Enter a valid email address'))
      .required(t(`${TP}.requiredEmail`, 'Email is a required field')),
  });
